<!-- <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" m-dropdown-toggle="click"> -->
<span>
  <span style="position: relative; top: 20px">
    <span class="my-dropdown-toggle {{ showDropdown ? 'active' : '' }}">
      <i
        class="flaticon-grid-menu cp"
        style="color: #ad5beb"
        (click)="toggleDropdown()"
      ></i>
      <div class="my-dropdown-container" #container>
        <div class="my-dropdown-content">
          <div
            class="my-dropdown-header"
            style="
              background: url(./assets/app/media/img/misc/user_profile_bg.jpg);
              background-size: cover;
            "
          >
            <div class="my-username">{{ tokenService.user.name }}</div>
            <div class="my-email">{{ tokenService.user.email }}</div>
            <div
              *ngIf="tokenService.user.pricing_plan"
              class="my-pricing-plan mt-1"
            >
              Pricing Plan: {{ tokenService.user.pricing_plan.name }}
            </div>
          </div>
          <ng-container *ngIf="isShowroomUser()">
            <!-- Profile -->
            <div class="mb-3">
              <i class="flaticon-profile-1 mr-4"></i>
              <span class="cp" (click)="navigateToMyProfile('showroom')"
                >My Profile</span
              >
            </div>
            <div class="mb-3">
              <i class="flaticon-coins mr-4"></i>
              <span (click)="navigateToSubscriptionInfo('showroom')" class="cp"
                >Subscription info</span
              >
            </div>
            <div class="mb-4" *ngIf="showMultiplierToggle">
              <i class="flaticon-settings mr-4"></i>
              <span class="mr-3">Display list price</span>
              <mat-slide-toggle
                [checked]="true"
                (change)="toggleMultiplier($event)"
              ></mat-slide-toggle>
            </div>
          </ng-container>
          <ng-container *ngIf="isVendorUser()">
            <!-- Profile -->
            <div class="mb-4">
              <i class="flaticon-profile-1 mr-4"></i>
              <span class="cp" (click)="navigateToMyProfile('vendor')"
                >My Profile</span
              >
            </div>
            <div class="mb-4">
              <i class="flaticon-folder-1 mr-4"></i>
              <span class="cp" (click)="navigateToProductUpdates()"
                >Product Updates</span
              >
            </div>
            <div class="mb-3" *ngIf="!(isPrivateLabel$ | async)">
              <i class="flaticon-coins mr-4"></i>
              <span (click)="navigateToSubscriptionInfo('vendor')" class="cp"
                >Subscription info</span
              >
            </div>
          </ng-container>
          <div>
            <span class="logout-button cp" (click)="logout()">Logout</span>
          </div>
        </div>
      </div>
    </span>
    <!-- <button class="btn btn-outline-info" (click)="logout()">Logout</button> -->
    <!-- <img src="{{avatar}}" class="m--img-rounded m--marginless m--img-centered" alt="" /> -->
  </span>
</span>
<!-- <div class="m-dropdown__wrapper"> -->
<!-- <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span> -->
<!-- <div class="m-dropdown__inner"> -->
<!-- <div class="m-dropdown__header m--align-center" #mProfileDropdown style="background-size: cover;" [style.background-image]="avatarBg">
			<div class="m-card-user m-card-user--skin-dark">
				<div class="m-card-user__pic">
					<img src="{{avatar}}" class="m--img-rounded m--marginless" alt="" />
				</div>
				<div class="m-card-user__details">
					<span class="m-card-user__name m--font-weight-500">
						Mark Andre
					</span>
					<a href="mailto:mark.andre@gmail.com" class="m-card-user__email m--font-weight-300 m-link">
						mark.andre@gmail.com
					</a>
				</div>
			</div>
		</div> -->
<!-- <div class="m-dropdown__body">
			<div class="m-dropdown__content">
				<ul class="m-nav m-nav--skin-light clearfix"> -->
<!-- <li class="m-nav__separator m-nav__separator--fit"></li> -->
<!-- <li class="m-nav__item float-right">
						<button mat-stroked-button (click)="logout()">Logout</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div> -->
<!-- </li> -->
